import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { sendEmail } from "utility/utility";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    ca: {
        translation: {
            PDFDownload: "PDF download",
            Document: "Document",
            LegalName: "Trade Name",
            ACAN: "Alberta Corporate Access Number",
            CorpName: "Legal Entity Name",
            BN: "Business Number",
            BusineseInfo: "Businese Info",
            ForgotPassword: "Reset Password",
            NotFoundMessage: "404! Page not found.",
            YoutubeHomeTitle: "Calgary Travel Agency, LoLo Tour",
            YoutubeHomeText:
                "Traveling with us will be even more meaningful and memorable.<br>",
            Banff: "Banff",
            BanffDescription:
                "Banff is famous for its majestic mountains and beautiful lakes, where you can see various wild animals such as deer and bears.<br>Create unforgettable moments in this world-renowned travel destination.",
            Rockies: "Rockies",
            RockyDescription:
                "Rocky Mountains in Alberta and British Columbia are renowned for their majestic mountains, beautiful lakes, and natural hot springs.<br>Explore this world-famous destination, where you can encounter various wildlife.",
            Jasper: "Jasper",
            JasperDescription:
                "Located in the heart of the Rocky Mountains, Jasper National Park is one of Canada's proud treasures.<br>Marvel at deep blue glacier lakes and majestic mountain ranges as you stroll through diverse and lush vegetation.<br>Additionally, encounter various wildlife such as bears, deer, wolves, and mountain sheep for an unforgettable experience.",
            Kananaskis: "Kananaskis",
            KananaskisDescription:
                "A heavenly playground within the Rocky Mountains.<br>Kananaskis in Alberta offers beautiful mountain landscapes, clear lakes, and various outdoor activities.",
            Calgary: "Calgary",
            CalgaryDescription:
                "Calgary, the largest city in Alberta, Canada, hosted the first Winter Olympics in 1988 and ranks 5th in population in Canada.<br>Thanks to the warm Chinook winds from the Rocky Mountains, winters are relatively mild compared to other regions in Canada.<br>Calgary is also famous for its Stampede, traditional music festivals, Lilac Festival, and Caribbean Festival.",
            Mexico: "Mexico",
            MexicoDescription:
                "Enjoy the beautiful landscapes and rich culture of Mexico.",
            Yellowknife: "Yellowknife",
            YellowknifeDescription:
                "Yellowknife, the capital of the Northwest Territories in Canada, is recognized by NASA as the world's best aurora observation site.<br>Surrounded by mountains within a thousand kilometers, you can enjoy the auroras without obstruction.<br>Experience the best ground-level aurora travel in Yellowknife.",
            Asia: "Asia",
            AsiaDescription:
                "Experience the allure of Asia - where every journey is a fusion of tradition and innovation, nature and urbanity, creating a travel experience like no other.",
            AccountInfo: "Account Info",
            IntroCEO: "About Us",
            ContactUs: "Contact Us",
            Login: "Login",
            SimpleSignup: "Signup",
            Logout: "Logout",
            Profile: "Profile",
            Signup: "Signup",
            EmailOrUserName: "Username or Email",
            Password: "Password",
            Email: "Email",
            Username: "Username",
            UsernameReq:
                "1-50 characters. Only numbers and letters are allowed.",
            PasswordReq:
                "3-20 characters. Numbers, letters, and _!@#$%^&* are allowed.",
            CEOPhone: "Inquiries",
            TripDays: "Travel Period",
            MinPerson: "Minimum Persons",
            Route: "Route",
            Price: "Price",
            TripInquire: "Reservation Inquiry",
            WriteTripInquire: "Write Reservation Inquiry",
            WriteNew: "Write New",
            TripBoardHeader: "Reservation Inquiry/Travel Reviews and Q&A Board",
            Category: "Category",
            Topic: "Topic",
            Replies: "Replies",
            Clicks: "Clicks",
            PostDate: "Post Time",
            NoPost: "No posts available.",
            BoardHeader: "Product Description",
            LoginFailed: "Login failed. Please try again.",
            Days: " day(s)",
            Persons: " person(s)",
            PlzLogin: "Please login first.",
            WriteLimit: "Can write 10 per day to prevent spam.",
            WriteContent: "Please write at least a title and content.",
            WriteBoard: "Write new",
            Title: "Title",
            Post: "Post",
            Close: "Close",
            Home: "Home",
            RegFailed: "Registration failed. Please try again later.",
            NoTourPackage:
                "We are preparing travel packages for this location.",
            Kakao: "Add Kakao ch. via QR",
            Deleted: "Deleted successfully.",
            NotDeleted: "Could not be deleted. Try again.",
            Updated: "Updated successfully.",
            NotUpdated: "Could not be updated. Try again.",
            Update: "Modify",
            Delete: "Delete",
            AddReply: "Add Reply",
            GeneralError: "Error occured.Please try again.",
            UnknownError: "Unknown error occured.Please try again.",
            LoggedOut: "You have been logged out.",
            ToHome: "Home",
            ReplyAdded: "Your reply has been added.",
            Cancel: "Cancel",
            ConfirmDeletion: "Confirm Deletion",
            DeletionMsg: "Are you sure you want to delete this?",
            Confirm: "Confirm",
            WriteMin: "Minimum 10 characters are required.",
            Product: "Product",
            Essential: "Essentials",
            Safety: "Safety/Precautions",
            Inexcluded: "Inclusions/Exclusions",
            RouteDetail: "Travel itinerary",
            Included: "Inclusions",
            Excluded: "Exclusions",
            Loading: "Loading...",
            NotLoggedinBoardMsg:
                "When a post is made, an email is sent to the admin, and when the admin replies, the reply is sent to the email used at the time of registration.",
            UseEmailCorrectly:
                "When you leave a post, an email is sent to the admin, and if the admin replies, the reply will be sent to {{email}}.",
            ReplyEmail:
                "When a post is made, an email is sent to the thread's initial poster and the admin.",
            Inquire: "Inquire",
            TobeNego: "Negotiable",
            YoutubeText:
                "Want to share precious memories with loved ones or cherish them for a long time? Our travel agency creates YouTube videos for FREE!",
            Discounted: "Discounted",
            Recommended: "Recommended",
            ContactUsTitle: "Contact Us",
            ContactUsDescription:
                "Do you have any questions? We will respond as quickly as possible.",
            RealTimeConsultation:
                "For real-time consultation, please use Kakao Talk.",
            SpamPrevention: "Spam Prevention",
            EnterNumericAnswer: "Enter the numeric answer",
            IncorrectAnswer: "Incorrect answer",
            PrivatePost: "Private Post",
            HideContentInBoard: "Hide content in the board",
            Sender: "Sender",
            Subject: "Subject",
            MinCharacters: "Must be at least {{count}} characters long.",
            Content: "Content",
            SpamPreventionLabel: "Spam Prevention",
            SpamPreventionPlaceholder: "Enter the result",
            SpamPreventionIncorrect: "Incorrect answer",
            ConsentLabel: "Consent",
            ConsentAgreeText:
                "Agree to receive travel information, events, and coupons",
            ConsentNotice:
                "For secure transactions, notices about travel product usage, terms, and service changes will be sent regardless of consent.",
            ConsentAllAgreeText: " Agree to all terms and privacy policy",
            ConsentTermsAgreeText: " Agree to Terms and Conditions",
            ConsentPrivacyAgreeText: " Agree to Privacy Policy",
            SignUpButton: "Sign Up",
            RegisterTitle: "Sign Up",
            RegisterDescription:
                "Create a new account to access exclusive features by LoLo Tour, Ltd.",
            UsernameLabel: "Login ID",
            UsernamePlaceholder: "1-10 characters",
            UsernameInUse: "Username is already in use",
            UsernameSpecialChar: "Username cannot contain special characters",
            EmailLabel: "Email",
            EmailPlaceholder: "Enter your email",
            EmailInUse: "Email is already in use",
            PasswordLabel: "Password",
            PasswordPlaceholder: "Minimum 6 characters",
            ConfirmPassword: "Confirm Password",
            PasswordMismatch: "Passwords do not match",
            VerifyEmailSubject: "Email Verification",
            EmailSentSuccess:
                "An email has been sent to {{email}}. Click on the 'Verify' link in the email to complete the registration. If you don't receive the email within 5 minutes, please check your Junk folder. If you still haven't received it, please contact us.",
            EmailSentError:
                "Email was not sent to {{email}}. Please check your email and try signing up again.",
            ErrorMessage:
                "An error occurred. Please contact us, and we will resolve it as soon as possible.",
            Required: "Required",
            EMAIL_VERIFICATION_TITLE: "Email Verification",
            EMAIL_VERIFICATION_DESCRIPTION1:
                "To complete the registration, you need to verify your email.",
            EMAIL_VERIFICATION_DESCRIPTION2:
                "Join LoLo Tour for the ability to post on the forum and enjoy various travel-related benefits.",
            EMAIL_VERIFICATION_SUCCESS:
                "Registration completed! Please log in.",
            EMAIL_VERIFICATION_FAILURE:
                "Email verification failed. Please contact support.",
            EMAIL_DOES_NOT_EXIST: "Email does not exist.",
            EMAIL_ALREADY_VERIFIED: "Email already verified.",
            INCORRECT_CODE: "Incorrect 5-digit code.",
            INTERNAL_SERVER_ERROR:
                "Internal server error. Please contact support.",
            EMAIL_LABEL: "Email",
            CODE_LABEL: "Code",
            VERIFY_BUTTON_TEXT: "Verify",
            VERIFY_EMAIL_SENT_LOADING_TEXT: "Sending verification email...",
            VERIFY_EMAIL_SENT_LOADING_ALT: "Loading",
            EmailFailed:
                "Failed to send email. Please try again or consider KakaoTalk live chat support.",
            ConfirmEmail: "Please confirm your email address.",
            EmailFailedGenericError:
                "Failed to send email. Please try again or consider KakaoTalk live chat support. Error:",
            EmailSent: "Email has been sent.",
            TandC: "Terms and Conditions",
            Privacy: "Privacy Policy",
            Attention: "Reference/Cautionary Notes",
            Hire: "Careers",
            TourTitle: "Trip Information",
            Show: "Show",
            Hide: "Hide",
            ShareProduct: "Share",
            TourName: "Tour Name",
            TourDesc: "Tour Description",
            InteractAddress: "Reservation Deposit Email",
            Interact: "info@lolotour.com",
            InteractMsg:
                "Deposit to info@lolotour.com using E-transfer (Interact) to confirm your reservation.",
            OnePersonRule: "Remarks",
            OnePersonRuleDesc:
                "Below product price is based on a minimum of 4 persons. Additional charges apply for less than 3 travellers or additional room requests, typically CAD$200 per day unless it is a day trip. Please inquire if this applies to you.",
            JoinTitle: "Anyone up for a trip together?",
            JoinDesc:
                "For reasons such as saving on accommodation costs, please contact us at <a href='mailto:info@lolotour.com'>info@lolotour.com</a> if you would like to join the schedule below. (The tour will proceed if the minimum number of participants is met.)",
            JoinMale: "Male",
            JoinFemale: "Female",
            JoinStart: "Start Date",
            JoinEnd: "End Date",
            JoinRemarks: "Remarks",
            PerPerson: "person",
            HJKim: "Kim Hee Jung",
            HJKimRole: "Co-CEO/Travel Guide",
            HJKimRemarks: "Kim Hee Jung guides most tours.",
            Gil: "Seol Ju Gil",
            GilRole: "Graphic Designer/Travel Guide",
            GilRemarks: "Likes to travel",
            Kai: "Kai",
            KaiRole: "Co-CEO/Web/Travel Guide",
            KaiRemarks: "",
            Lym: "Lym Lee",
            LymRole: "Travel Guide",
            JadeRole: "Travel Guide/Marketing",
            LymRemarks: "Handles women-only tours only upon request.",
            IHKim: "Ilho Cho",
            IHKimRole: "Program Coordinator",
            JEKang: "JungEun Kang",
            JEKangRole: "Travel Guide",
            SMLee: "SuMin Lee",
            SMLeeRole: "Travel Counseller",
            DEHan: "Doui Han",
            DEHanRole: "Travel Guide",
            DEHanRemarks:
                "Scuba Diving Instructor. Snowboard Instructor. Freediving Lv2 certificate holder.",
            JadeRemarks: "Fluent in Chinese (Mandarin), English, and French",
            beneficiaryBank: "Beneficiary's Bank",
            branchName: "Branch Name",
            routingNo: "Routing Number",
            beneficiaryBankAddress: "Beneficiary Bank Address",
            beneficiaryName: "Beneficiary Name",
            beneficiaryAddress: "Beneficiary Address",
            transitNumber: "Transit Number",
            institutionCode: "Institution (Bank) Code",
            accountNumber: "Account Number",
            swiftBIC: "SWIFT/BIC",
            accountType: "Account Type",
            LinkToTour: "Check out this travel product",
            TourReview: "Tour Review",
            Logo: "LOLO TOUR",
            NumberOfPeople: "Travelers",
            PricePerPerson: "Per person",
            TotalPrice: "Total",
            Subtotal: "Sub-total",
            GST: "Alberta GST",
            WON: "Won",
            PaymentInfo:
                "To confirm your travel reservation, please make a deposit of CAD $20 or KRW 20,000 via <2>PayPal</2> or <3>Interact</3> to <1>info@lolotour.com</1>. Upon receipt of the deposit, your reservation will be confirmed, and a payment confirmation statement will be sent to you upon request. This deposit will be deducted from the final payment amount. Kindly ensure the availability of your selected travel date before proceeding with the payment.",
            SendEmail: "Send Email",
            ReadMore: "Read More",
            Collapse: "Collapse",
            LinkedIn: "LinkedIn Profile",
            Staff: "Staff",
            Car: "Car",
            CarDesc: "2026 Tesla Model Y is used for travel.",
            CeoGreetingHeader: "Greetings from the CEO",
            CeoGreetingText: `Hello! 🙋‍♂️ LOLO TOUR is a Korean private tour specialist officially registered in Calgary. We offer customized private tours for 1 to 4 people, providing the best value-for-money private tours from Calgary to the Rockies.
            <br /><br />
            <ul>
                <li><b>Vehicle & Service</b>: We conduct comfortable and classy trips with a 5-seater Lexus hatchback.</li>
                <li><b>Local Expertise</b>: With over 15 years of living in Calgary, we incorporate rich experience and know-how, blending the hidden charms of Calgary and the Rockies into our tours for a deeper exploration.</li>
                <li><b>Customized Private Tours</b>: Leveraging the advantages of private tours, we flexibly adjust itineraries based on customer requests, promising high-satisfaction services tailored to Korean travelers' tastes and expectations.</li>
            </ul>
            This trip may be a once-in-a-lifetime precious experience. LOLO TOUR will do its utmost to ensure your valuable time and investment yield the highest value. Contact us now! 🚀✨`,
            BiographyHeader: "Owner/Guide Biography",
            Bio1: "Discharged as a sergeant from the Republic of Korea Army",
            Bio2: "Graduated from the Department of Computer Science at the University of Calgary",
            Bio3: "Worked as a Principal Software Engineer at Symantec(now BroadCom)",
            Bio4: "Calgary resident for 15+ years. Specialized Banff/Jasper guide since 2024",
            companyDescription: `
               <p>Hello! 🙋‍♂️ Rolo Tour is a small, officially registered private tour company in Calgary. We offer private tours from 1 to 4 people, providing the best value Korean-friendly private tours from Calgary to the Rockies with confidence! 🚀✨</p>
        
                <h5>1️⃣ Advantages of Rolo Tour</h5>
                <ul>
                    <li><strong>Transparent Pricing:</strong> We do not receive commissions from hotels, stores, or restaurants. We find cost-effective locations based on season and place to reduce your hassle. We do not sell vouchers or additional products beyond the tour cost. No additional fees beyond the listed inclusions!</li>
                    <li><strong>Comfortable Travel:</strong> We provide the best riding experience with a high-end leather seat Lexus 5-seater hatchback carefully maintained.</li>
                    <li><strong>Customized Itinerary:</strong> We can adjust the schedule according to your preferences and accommodate requests for travel destination modifications.</li>
                    <li><strong>Local Hidden Spots:</strong> We guide you to special places and photo spots known only to local guides, not just typical tourist destinations.</li>
                    <li><strong>Convenient Transportation:</strong> Free pickup service within Calgary, Canmore, and Banff with no additional costs.</li>
                    <li><strong>Small Private Tour:</strong> Private tours exclusively for one group, from 1 to 4 people.</li>
                    <li><strong>Flexible Schedule:</strong> If canceled up to 7 days before the tour, a full refund will be issued, excluding the booking/transfer fee (up to C$5).</li>
                    <li><strong>Photo-Centric Tours:</strong> If you're interested in photography, we can conduct tours focused on snapshot photography.</li>
                    <li><strong>Local Expertise:</strong> We guide you with professional knowledge and experience to enjoy Banff/Rockies moments to the fullest.</li>
                </ul>
                
                <h5>2️⃣ Premium Services</h5>
                <ul>
                    <li><strong>Lifetime Photo Shooting:</strong> Based on years of experience taking snapshots in Banff, we'll capture wonderful photos. Original photos will be immediately sent for free without any editing right after the trip.</li>
                    <li><strong>Additional Services:</strong> Free umbrella, water, and simple snacks.</li>
                </ul>
                
                <h5>3️⃣ Recommended For</h5>
                <ul>
                    <li>Honeymoon couples wanting to capture beautiful snapshots in the picturesque Banff landscape.</li>
                    <li>Individual travelers, couples, and family travelers seeking premium tours.</li>
                    <li>Those who want to enjoy the Rockies leisurely without crowded tourist spots.</li>
                </ul>
                
                <h5>✨ Contact Us Comfortably</h5>
                <p>This trip might be a once-in-a-lifetime precious experience. To ensure your carefully prepared time and budget are not wasted, Rolo Tour will create special memories that will be remembered for a long time. Contact us comfortably, and we'll respond with the highest quality service!</p>
                
                <h5>⭕ Additional Notes</h5>
                <p>Moraine Lake shuttle ticketing can be particularly difficult to book during peak season. If you wish to visit this location, please inquire as soon as possible after reservation confirmation. 😊</p>`,
            Career: {
                JobPosting: "Job Posting",
                JobDescription:
                    "We are looking for talented individuals to join our team at LoloTour, Calgary's premier Korean private tour company.",
                CRMManager: "CRM and Marketing Manager (1 position)",
                JobDetails: "Job Details",
                CRMJobDesc1: "- CRM Channel Operation/Management",
                CRMJobDesc2:
                    "Develop and execute strategies for KakaoTalk (Friend Talk, Notification Talk), app push, SMS, and other CRM channels.",
                CRMJobDesc3:
                    "Analyze customer data and behavior to derive insights, create and execute CRM strategies for different segments.",
                CRMJobDesc4:
                    "Use data analysis tools to operate, execute, analyze, and automate CRM campaigns.",
                CRMJobResult:
                    "- Analyze campaign performance and optimize costs and efficiency.",
                CRMJobResult2:
                    "Collaborate with product, business teams, and others to provide customer insights.",
                CRMOtherTasks: "- Other various marketing tasks",
                Qualifications: "Qualifications",
                RequiredExperience:
                    "[Required] 3+ years of experience in CRM marketing",
                RequiredSkills:
                    "[Required] Proven past marketing performance backed by data",
                RequiredTools:
                    "Experience in campaign planning/execution/analysis with data tools (e.g., Braze, Airbridge)",
                DecisionMakingSkills:
                    "Comfortable with data-driven decision-making and communication",
                CollaborationSkills:
                    "Experience in collaborating across departments (business, PO, design) with strong communication skills",
                TAManager: "T&A Business Development Manager (1 position)",
                TAJobDesc1:
                    "Develop new categories in Tours & Activities and expand existing categories.",
                TAJobDesc2:
                    "Create and execute strategies to increase Tours & Activities revenue.",
                TAJobDesc3:
                    "Discover new B2C/B2B partners and build strategic partnerships.",
                Qualifications2:
                    "We are looking for individuals with the following skills:",
                TARequiredSkills:
                    "Experience in developing global business strategies for Tours & Activities.",
                TARequiredExperience:
                    "Experience in discovering B2C/B2B partners and building strategic partnerships.",
                PreferredQualifications: "Preferred Qualifications",
                TAPreferredExperience1:
                    "Experience in startups, platforms, e-commerce, or global IT companies.",
                TAPreferredExperience2:
                    "Business-level English communication skills",
                TourGuide: "Tour Guide (3 positions)",
                TourGuideDesc1:
                    "Guide and introduce tourist attractions and cultural heritage.",
                TourGuideDesc2:
                    "Accompany travelers and explain the local culture and history.",
                TourGuideDesc3:
                    "Organize various travel activities and encourage participation.",
                Qualifications3:
                    "We are looking for individuals with the following skills:",
                TourGuideRequiredSkills1:
                    "3+ years of experience in the travel industry.",
                TourGuideRequiredSkills2:
                    "Deep knowledge of local history, culture, and culinary tourism.",
                TourGuideRequiredSkills3:
                    "Ability to communicate effectively with travelers from various nationalities and languages.",
                PreferredQualifications2: "Preferred Qualifications",
                TourGuidePreferredSkills1:
                    "Fluent in foreign languages (English, Chinese, Japanese, etc.)",
                TourGuidePreferredSkills2:
                    "Possession of local qualification certifications",
                TourGuidePreferredSkills3:
                    "Possession of Trail Guide certification",
                TourGuidePreferredSkills4: "Extensive global travel experience",
                ApplicationInstructions: "How to Apply",
                SendEmailInstructions:
                    "Send a brief introduction with a photo (required) and resume to",
                ClickHere: "Click here",
                SendLinkedIn: "to send your LinkedIn or website address.",
            },
        },
    },
    kr: {
        translation: {
            PDFDownload: "PDF 다운로드",
            Document: "서류",
            LegalName: "사업자명",
            ACAN: "알버타 기업번호",
            CorpName: "법인 이름",
            BN: "사업자 등록번호",
            BusineseInfo: "비즈니스 정보",
            ForgotPassword: "비밀번호 재설정하기",
            NotFoundMessage: "404! 주소를 찾을수 없습니다.",
            YoutubeHomeTitle: "프라이빗 투어 전문여행사 롤로투어",
            YoutubeHomeText:
                "여러분의 소중한 시간과 비용이 헛되지 않도록 최선을 다하겠습니다!",
            Rockies: "록키(Rockies)",
            RockyDescription:
                "캐나다 알버타와 브리티시 컬럼비아주의 록키는 웅장한 산과 아름다운 호수가 어우러진 자연 경관, 온천으로 유명합니다.<br>사슴과 곰 등 여러 종의 야생 동물을 볼 수 있는 세계적인 여행지에서 잊지 못할 시간을 만들어보세요.",
            Banff: "밴프(Banff)",
            BanffDescription:
                "밴프는 웅장한 산과 아름다운 호수가 어우러진 자연 경관으로 유명합니다.<br>사슴과 곰 등 여러 종의 야생 동물을 볼 수 있는 세계적인 여행지에서 잊지 못할 시간을 만들어보세요.",
            Jasper: "재스퍼(Jasper)",
            JasperDescription:
                "로키 산맥의 중심부에 자리한 재스퍼 국립 공원은 캐나다의 자랑스러운 보물 중 하나입니다.<br>깊고 푸른 빙하 호수와 웅장한 설산에 감탄하며 다양하고 무성한 식물 사이를 거닐 수 있습니다.<br>여기에 더해, 곰, 순록, 늑대, 산양과 같은 다양한 야생동물이 여러분에게 잊지 못할 경험을 선사할 것입니다.",
            Kananaskis: "카나나스키스(Kananaskis)",
            KananaskisDescription:
                "록키 산맥 속의 천혜의 놀이터, 알버타주 카나나스키스.<br>원시림에 둘러싸인 이곳은 아름다운 산맥 풍경, 맑은 호수, 자연을 사랑하는 이들과 모험을 즐기는 이들을 위한 다양한 야외 활동을 제공합니다.",
            Calgary: "캘거리(Calgary)",
            CalgaryDescription:
                "캐나다에서 최초로 1988년 동계 올림픽이 개최된 캘거리는 앨버타 주에서 제일 큰 도시이며 인구수로 캐나다에서 5위를 차지하고 있습니다.<br>록키산맥으로부터 시눅(Chinook)이라는 따듯한 바람이 불어와서 캐나다 다른 지역보다 상대적으로 겨울이 더 따듯합니다.<br>스탬피드, 전통 음악 축제, 라일락 축제, 그리고 캐리비안 축제 등 여러 유명한 축제로 유명합니다.",
            Mexico: "멕시코",
            MexicoDescription: "멕시코의 아름다운 풍경과 문화를 즐겨보세요.",
            Yellowknife: "옐로나이프(Yellowknife)",
            YellowknifeDescription:
                "캐나다 노스웨스트 준주의 주도 옐로나이프는 미국 항공우주국 NASA가 선정한 세계 최고의 오로라 관측지입니다.<br>연중 오로라가 출몰하는 오로라 오벌(Oval) 지역에 속하고, 사방 천 킬로미터 이내에 산맥이 존재하지 않아 시야의 방해 없이 오로라를 즐기실 수 있습니다.<br>옐로나이프에서 지상 최고의 오로라 여행을 만끽해보세요.",
            Asia: "아시아",
            AsiaDescription:
                "아시아의 매력을 체험하세요 - 모든 여정이 전통과 혁신, 자연과 도시의 융합으로 이루어진, 그 어떤 다른 여행 경험과도 다른 특별한 경험을 창조합니다.",
            AccountInfo: "계좌정보",
            Inquire: "문의바랍니다",
            ContactUs: "문의하기",
            IntroCEO: "롤로투어 소개",
            Login: "로그인",
            SimpleSignup: "간편가입",
            Logout: "로그아웃",
            Profile: "프로필",
            Signup: "가입하기",
            EmailOrUserName: "아이디 또는 이메일",
            Password: "패스워드",
            Email: "이메일",
            Username: "사용자 이름",
            UsernameReq: "1~50자. 숫자와 알파벳만 허용됩니다.",
            PasswordReq: "3~20자. 숫자, 알파벳과 _!@#$%^&*가 허용됩니다.",
            CEOPhone: "주소/연락처",
            TripDays: "여행기간",
            MinPerson: "최소인원",
            Route: "여정",
            Price: "가격",
            TripInquire: "예약문의",
            WriteTripInquire: "예약문의 글쓰기",
            WriteNew: "새 글쓰기",
            TripBoardHeader: "예약문의/여행후기 및 질문게시판",
            Category: "분류",
            Topic: "토픽",
            Replies: "답글수",
            Clicks: "클릭수",
            PostDate: "등록시간",
            NoPost: "게시글이 없습니다.",
            BoardHeader: "여행 상품 설명",
            LoginFailed: "로그인에 실패했습니다. 다시 시도해주세요.",
            Days: "일",
            Persons: "명",
            PlzLogin: "로그인 하세요.",
            WriteContent: "제목과 내용을 써 주세요.",
            WriteLimit:
                "스팸을 막기위해 하루에 최대 10개만 글을 쓸 수 있게하고 있으니 양해부탁드립니다.",
            WriteBoard: "게시판 글쓰기",
            Title: "제목",
            Post: "게시하기",
            Close: "닫기",
            Home: "홈페이지",
            RegFailed: "등록에 실패하였습니다. 다시시도해보세요.",
            NoTourPackage: "이 지역 여행상품을 준비중입니다.",
            Kakao: "카톡상담 QR코드",
            Deleted: "삭제되었습니다.",
            NotDeleted: "삭제되지 않았습니다. 다시 시도해보세요.",
            Updated: "업데이트 되었습니다.",
            NotUpdated: "업데이트되지 않았습니다. 다시 시도해보세요.",
            Update: "수정",
            Delete: "삭제",
            AddReply: "답글달기",
            GeneralError: "문제가 생겼습니다. 다시 시도해주세요.",
            UnknownError: "예상치 못한 문제가 생겼습니다. 다시 시도해주세요.",
            LoggedOut: "로그아웃 되었습니다.",
            ToHome: "홈으로 가기",
            ReplyAdded: "답글이 등록되었습니다.",
            Cancel: "취소",
            ConfirmDeletion: "삭제확인",
            DeletionMsg: "정말 이 글을 지우시겠습니까?",
            Confirm: "확인",
            WriteMin: "10글자 미만의 글은 허용하지 않습니다.",
            Product: "상품소개",
            Essential: "유의사항",
            Safety: "안전/주의사항",
            Inexcluded: "포함/불포함",
            RouteDetail: "여행 일정",
            Included: "포함사항",
            Excluded: "불포함사항",
            Loading: "로딩중...",
            NotLoggedinBoardMsg:
                "글을 남기면 관리자에게 이메일이 전송되고, 관리자가 답변을 달면 가입시 사용한 이메일로 답변이 전송됩니다.",
            UseEmailCorrectly:
                "글을 남기면 관리자에게 이메일이 전송되고, 관리자가 답변을 달면 {{email}}로 답변이 전송됩니다.",
            ReplyEmail:
                "답변은 이메일로 이 게시물 초기 작성자와 관리자에게 전송됩니다.",
            TobeNego: "협의가능",
            YoutubeText:
                "여행의 소중한 추억을 소중한 사람들과 나누거나 오래도록 간직하고 싶으신가요? 저희 여행사는 무료로 Youtube영상을 만들어 드립니다.",
            Discounted: "할인상품",
            Recommended: "추천상품",
            ContactUsTitle: "문의하기",
            ContactUsDescription:
                "궁금한것이 있으신가요? 최대한 빠르게 답변드리겠습니다.",
            RealTimeConsultation:
                "실시간 상담은 카카오 상담하기를 이용해 주세요.",
            SpamPrevention: "스팸방지",
            EnterNumericAnswer: "숫자로 정답을 써주세요",
            IncorrectAnswer: "정답이 아닙니다",
            PrivatePost: "비밀글",
            HideContentInBoard: "게시판에서 내용숨기기",
            Sender: "보내는 사람",
            Subject: "제목",
            MinCharacters: "최소 {{count}}자 이상이어야합니다.",
            Content: "내용",
            SpamPreventionLabel: "스팸 방지",
            SpamPreventionPlaceholder: "결과를 입력하세요",
            SpamPreventionIncorrect: "정답이 아닙니다",
            ConsentLabel: "수신 동의",
            ConsentAgreeText: "여행 정보, 이벤트 및 쿠폰 수신에 동의합니다",
            ConsentNotice:
                "안전한 거래를 위해 여행 상품 이용 사항, 약관 및 서비스 변경에 대한 공지는 수신 동의 여부와 상관없이 발송됩니다.",
            ConsentAllAgreeText:
                "이용 약관 및 개인 정보 수집 및 이용에 모두 동의합니다",
            ConsentTermsAgreeText: "이용 약관에 동의합니다 (필수)",
            ConsentPrivacyAgreeText:
                "개인 정보 수집 및 이용에 동의합니다 (필수)",
            SignUpButton: "가입하기",
            RegisterTitle: "가입하기",
            RegisterDescription:
                "지금 롤로투어에 가입하셔서 여행과 관련된 다양한 혜택을 누리세요.",
            UsernameLabel: "아이디(사용자 이름)",
            UsernamePlaceholder: "1~10자의 한글/영어/숫자",
            UsernameInUse: "사용자 이름이 이미 사용 중입니다",
            UsernameSpecialChar:
                "사용자 이름에는 특수 문자를 포함할 수 없습니다",
            EmailLabel: "이메일",
            EmailPlaceholder: "이메일을 입력하세요",
            EmailInUse: "이메일이 이미 사용 중입니다",
            PasswordLabel: "비밀번호",
            PasswordPlaceholder: "최소 6자 비밀번호",
            ConfirmPassword: "비밀번호 확인",
            PasswordMismatch: "비밀번호가 일치하지 않습니다",
            VerifyEmailSubject: "이메일 인증",
            EmailSentSuccess:
                "{{email}}로 이메일이 전송되었습니다. 이메일의 '인증하기' 링크를 클릭하여 등록을 완료하세요. 이메일이 5분 내에 도착하지 않으면 Junk 폴더도 확인하세요. 아직 받지 못했다면 문의하기로 문의하세요.",
            EmailSentError:
                "{{email}}로 이메일이 전송되지 않았습니다. 이메일을 확인하고 다시 가입을 신청하세요.",
            ErrorMessage:
                "오류가 발생했습니다. 문의주시면 최대한 빨리 해결해 드리겠습니다.",
            Required: "필수",
            EMAIL_VERIFICATION_TITLE: "이메일 인증하기",
            EMAIL_VERIFICATION_DESCRIPTION1:
                "회원가입을 마치려면 이메일을 인증해야합니다.",
            EMAIL_VERIFICATION_DESCRIPTION2:
                "롤로투어에 가입하시면 게시판에 글을 남기실 수 있으며 여행과 관련된 다양한 혜택을 드립니다.",
            EMAIL_VERIFICATION_SUCCESS:
                "회원가입이 완료되었습니다! 로그인 해주세요.",
            EMAIL_VERIFICATION_FAILURE:
                "이메일 인증에 실패했습니다. 문의바랍니다.",
            EMAIL_DOES_NOT_EXIST: "이메일이 존재하지 않습니다.",
            EMAIL_ALREADY_VERIFIED: "이미 인증된 이메일입니다.",
            INCORRECT_CODE: "5자리 숫자 코드가 다릅니다.",
            INTERNAL_SERVER_ERROR: "서버 오류입니다. 문의바랍니다.",
            EMAIL_LABEL: "이메일",
            CODE_LABEL: "코드",
            VERIFY_BUTTON_TEXT: "인증하기",
            VERIFY_EMAIL_SENT_LOADING_TEXT: "인증 메일 전송 중...",
            VERIFY_EMAIL_SENT_LOADING_ALT: "로딩 중",
            EmailFailed:
                "이메일 전송에 실패했습니다. 다시 시도해 보거나 카카오 실시간 상담하기를 추천드립니다.",
            ConfirmEmail: "이메일 주소를 확인바랍니다.",
            EmailFailedGenericError:
                "이메일 전송에 실패했습니다. 다시 시도해 보거나 카카오 실시간 상담하기를 추천드립니다. 에러:",
            EmailSent: "이메일이 전송되었습니다.",
            TandC: "이용약관",
            Privacy: "개인정보 취급방침",
            Attention: "유의사항",
            Hire: "채용정보",
            TourTitle: "여행정보",
            Show: "보이기",
            Hide: "숨기기",
            ShareProduct: "공유",
            TourName: "여행 이름",
            TourDesc: "간단한 설명",
            InteractAddress: "예약금 송금 이메일",
            Interact: "info@lolotour.com",
            InteractMsg:
                "E-transfer (Interact)를 이용해 info@lolotour.com로 여행비용을 지불하면 예약이 확정됩니다.",
            OnePersonRule: "참고",
            OnePersonRuleDesc:
                "당일 여행은 인원에 상관없이 추가비용은 없습니다. 하지만, 1박이상 숙박하는 상품 가격은 최소인원 4명 이상을 기준으로 하며, 3명이하 여행이나 별도 객실 추가 시 추가 비용이 발생합니다. 추가 비용은 보통 하루당 CAD$200입니다. 해당 고객님은 예약 전 문의바랍니다.",
            JoinTitle: "같이 여행하실분?",
            JoinDesc:
                "숙박비 절약등의 이유로 아래 일정에 함께 하시려면 <a href='mailto:info@lolotour.com'>info@lolotour.com</a>로 문의 바랍니다. (최소인원이 충족되면 투어는 진행합니다.)",
            JoinMale: "남자 인원수",
            JoinFemale: "여자 인원수",
            JoinStart: "희망 출발일",
            JoinEnd: "희망 도착일",
            JoinRemarks: "특이사항",
            PerPerson: "1인부터",
            Kai: "카이",
            KaiRole: "대표/웹개발/가이드",
            KaiRemarks: "",
            Lym: "이림",
            LymRole: "가이드",
            LymRemarks: "여성투어만 요청시 진행합니다.",
            DEHan: "한도의",
            DEHanRole: "가이드",
            DEHanRemarks:
                "스쿠버 다이빙, 스노보딩, 프리다이빙 레벨2 자격증 소지. 군필.",
            JadeRole: "가이드/홍보",
            JadeRemarks: "중국어(만다린)/영어/프렌치 능통",
            beneficiaryBank: "수취은행",
            branchName: "브랜치 이름",
            routingNo: "라우팅 번호",
            beneficiaryBankAddress: "수취은행 주소",
            beneficiaryName: "수취인 이름",
            beneficiaryAddress: "수취인 주소",
            transitNumber: "트랜짓 넘버",
            institutionCode: "기관 코드 (은행 코드)",
            accountNumber: "계좌 번호",
            swiftBIC: "SWIFT/BIC",
            accountType: "계좌 종류",
            LinkToTour: "해당 여행상품 구경하기",
            TourReview:
                "여행 후기 - 6월 18일 이후의 여행들은 인스타그램에 업로드합니다!",
            Logo: "롤로투어",
            NumberOfPeople: "인원",
            PricePerPerson: "1인당 가격",
            TotalPrice: "총 가격",
            Subtotal: "합계(소계)",
            GST: "알버타 주세(GST)",
            WON: "원",
            PaymentInfo:
                "우리은행 284-060844-02-201으로 50,000원을 입금하거나 <1>info@lolotour.com</1>로 <2>PayPal</2> 또는 <3>Interact</3>를 통해 CAD $50을 입금하면, 예약이 확정되며 요청시 결제 내역서를 발송해 드립니다. 이 비용은 최종 결제 요금에서 차감됩니다. 송금 전 반드시 해당 여행 날짜의 예약 가능 여부를 확인한 후 송금해 주시기 바랍니다.",
            SendEmail: "이메일 보내기",
            ReadMore: "더보기",
            Collapse: "닫기",
            LinkedIn: "링크드인 프로필",
            Staff: "스태프",
            Car: "차량",
            CarDesc:
                "여행에 사용되는 세계에서 가장 안전한 차중 하나인 테슬라 2026년형 Model Y입니다.",
            CeoGreetingHeader: "대표 인사말",
            CeoGreetingText: `안녕하세요, 롤로투어의 Kai입니다!🙋‍♂️ 여러분의 귀중한 시간과 비용이 최고의 가치로 남을 수 있도록 노력하겠습니다. 지금 바로 문의하세요! 🚀✨`,
            BiographyHeader: "대표/가이드 이력",
            Bio1: "대한민국 육군 병장 제대",
            Bio2: "캘거리 대학교 컴퓨터 공학과 졸업",
            Bio3: "Symantec(현 브로드컴) 수석 소프트웨어 엔지니어로 재직",
            Bio4: "캘거리 15년 이상 거주. 2024년부터 밴프/록키 전문 가이드로 활동",
            companyDescription: `
                <p>롤로투어는 가이드 활동부터 홈페이지, 인스타 및 상담까지 대표가 1인으로 운영하여 불필요한 거품을 뺀 합리적인 가격을 제공합니다. 다른 팀과의 합승 없이, 26년 테슬라 Y와 함께 오직 우리 팀(1~4인)만 단독으로 편안하고 자유롭게 여행하세요!  1박 2일 상품도 있으며, 더 여유로운 일정의 2박 3일, 혹은 3박 4일도 가능하니 문의 바랍니다!🚀✨</p>
                
                <p>📢 왜 롤로투어인가요?</p>
                <ul>
                    <li><strong>🚙 26년식 테슬라 Y </strong>– 쾌적한 26년식 테슬라 Y – 오래되거나 냄새나는 차 때문에 여행을 망치는 일은 없어야 하니까요. 롤로투어는 매 투어마다 항균 타월로 차량 내부를 청소합니다. 세계 최고 수준의 안전성과 자율주행 성능을 자랑하는 프리미엄 SUV와 함께 차원이 다른 편안함을 느껴보세요!</li>
                    <li><strong>💰 투명한 가격 </strong>– 상품가격이 곧 최종가격 (캘거리 외곽 픽업/드랍 시 인원 무관 각 C$20(왕복 최대 C$40) 추가될수있습니다. 캘거리 다운타운 10km 이내 및 밴프/캔모어 지역은 추가비용 없습니다.)</li>
                    <li><strong>❌ 커미션 없음 </strong>– 쇼핑·옵션 강요 없이 자유로운 여행</li>
                    <li><strong>🗺️ 맞춤 일정 </strong>– 원하는 코스로 자유롭게</li>
                    <li><strong>📍 전 지역 픽업 </strong>– 캘거리·캔모어·밴프 가능</li>
                    <li><strong>📸 인생 사진 </strong>– 다년간의 스냅샷 촬영 경험을 바탕으로 갤럭시 S25를 이용해 촬영하여 원본 사진들을 보내드립니다.</li>
                    <li><strong>🛡️ 안전 보장 </strong>– 사업자 책임 보험 가입으로 안심 여행</li>
                    <li><strong> 🏞️ 국립공원 상업 라이센스 보유 </strong>– 합법적으로 모든 경로 안내</li>
                </ul>
                
                <p>✨ 소중한 여행, 오래 기억에 남도록 함께하겠습니다. 👉 지금 편하게 문의하세요~ 🙂</p>`,
            Career: {
                JobPosting: "채용공고",
                JobDescription:
                    "캘거리 최고의 한인 프라이빗 투어전문 여행사 롤로투어와 함께할 인재를 모집합니다.",
                CRMManager: "CRM 및 마케팅 매니저 (1명)",
                JobDetails: "업무내용",
                CRMJobDesc1: "- CRM 채널 운영/관리",
                CRMJobDesc2:
                    "카카오톡 채널 (친구톡, 알림톡), 앱 푸시, 문자 등 CRM 채널별 전략을 수립하고 실행합니다.",
                CRMJobDesc3:
                    "고객정보와 행동을 기반으로 인사이트를 도출하고 세그먼트별로 CRM 전략을 수립하고 실행합니다.",
                CRMJobDesc4:
                    "데이터 분석 툴을 활용해 전반적인 CRM 캠페인을 운영/실행/분석하고 싸이클/자동화합니다.",
                CRMJobResult:
                    "- 캠페인 집행 결과에 따른 성과 분석, 비용 및 효율 최적화",
                CRMJobResult2:
                    "프로덕트, 사업팀 등과 협업하며 고객 관련 인사이트를 제공합니다.",
                CRMOtherTasks: "- 기타 다양한 마케팅 활동",
                Qualifications: "자격조건",
                RequiredExperience:
                    "[필수] 3년 이상의 CRM 마케팅 업무경험이 있는 분",
                RequiredSkills:
                    "[필수] 데이터로 증명이 가능한 과거 마케팅 성과",
                RequiredTools:
                    "데이터 툴 (Braze, Airbridge 등)을 활용한 캠페인 기획/실행/분석의 경험이 있는 분",
                DecisionMakingSkills:
                    "데이터 중심의 의사결정과 커뮤니케이션 경험이 익숙하신 분",
                CollaborationSkills:
                    "사업, PO, 디자인 등 다양한 유관부서와 협업 경험이 많고 커뮤니케이션이 원활한 분",
                TAManager: "T&A 사업개발 매니저 (1명)",
                TAJobDesc1:
                    "투어&액티비티 신규 카테고리 개발 및 기존 카테고리 상품 확장",
                TAJobDesc2: "투어&액티비티 매출 증대 사업 전략 수립 및 실행",
                TAJobDesc3:
                    "신규 B2C/B2B 파트너사 발굴 및 전략적 파트너쉽 구축",
                Qualifications2: "이런 역량이 있는 분들을 찾고 있어요.",
                TARequiredSkills:
                    "투어&액티비티 글로벌 매출 증대 사업 전략 수립 및 실행",
                TARequiredExperience:
                    "신규 B2C/B2B 파트너사 발굴 및 전략적 파트너쉽 구축",
                PreferredQualifications: "우대사항",
                TAPreferredExperience1:
                    "창업/스타트업/플랫폼/e-커머스/글로벌 IT기업에서의 업무 경험",
                TAPreferredExperience2:
                    "비즈니스 레벨 이상의 영어 커뮤니케이션 능력",
                TourGuide: "여행 가이드 (3명)",
                TourGuideDesc1: "관광 명소 및 문화 유산을 소개하고 안내하기",
                TourGuideDesc2:
                    "여행자들에게 지역의 특색과 역사를 설명하며 동행하기",
                TourGuideDesc3:
                    "다양한 여행 활동 및 이벤트를 조직하고 참여 유도하기",
                Qualifications3: "이런 역량이 있는 분들을 찾고 있어요.",
                TourGuideRequiredSkills1:
                    "3년 이상 여행 관련 업무 경험이 있는 분",
                TourGuideRequiredSkills2:
                    "지역의 역사, 문화, 미식 여행 등에 대한 깊은 지식을 가진 분",
                TourGuideRequiredSkills3:
                    "다양한 국적 및 언어의 여행자와 원활한 소통이 가능한 분",
                PreferredQualifications2: "우대사항",
                TourGuidePreferredSkills1:
                    "외국어 능통자 (영어, 중국어, 일본어 등)",
                TourGuidePreferredSkills2: "지역 관련 자격증 소지자",
                TourGuidePreferredSkills3: "Trail 가이드 자격증 소지자",
                TourGuidePreferredSkills4: "세계 여행 경험이 풍부한 분",
                ApplicationInstructions: "지원방법",
                SendEmailInstructions:
                    "간단한 본인소개와 함께 사진(필수)과 이력서를 보내시거나,",
                ClickHere: "여기를 클릭",
                SendLinkedIn: "하여 LinkedIn이나 사이트 주소를 보내주십시요.",
            },
        },
    },
    cn: {
        translation: {
            PDFDownload: "PDF下载",
            Document: "文件",
            LegalName: "商业名称",
            ACAN: "阿尔伯塔企业访问编号",
            CorpName: "法人实体名称",
            BN: "商业编号",
            BusineseInfo: "商业信息",
            ForgotPassword: "重置密码",
            NotFoundMessage: "404！页面未找到。",
            YoutubeHomeTitle: "与可爱的Jade一起畅游班夫的私人之旅",
            YoutubeHomeText: "与Jade和LOLO旅游一起旅行将更加有意义和难忘。<br>",
            Banff: "班夫",
            BanffDescription:
                "班夫以其雄伟的山脉和美丽的湖泊而闻名，您可以在这里看到鹿、熊等各种野生动物。<br>在这个世界知名的旅游目的地创造难忘的时刻。",
            Rockies: "落基山脉",
            RockyDescription:
                "阿尔伯塔和不列颠哥伦比亚的落基山脉以其雄伟的山脉、美丽的湖泊和天然温泉而闻名。<br>探索这个世界著名的目的地，您可以遇到各种野生动物。",
            Jasper: "贾斯珀",
            JasperDescription:
                "位于落基山脉中心的贾斯珀国家公园是加拿大的骄傲之一。<br>漫步在多样且郁郁葱葱的植被中，欣赏深蓝色冰川湖泊和雄伟的山脉。<br>此外，遇到熊、鹿、狼和山羊等各种野生动物，体验难忘的经历。",
            Kananaskis: "卡纳纳斯基斯",
            KananaskisDescription:
                "落基山脉中的天堂游乐场。<br>阿尔伯塔的卡纳纳斯基斯提供美丽的山景、清澈的湖泊和各种户外活动。",
            Calgary: "卡尔加里",
            CalgaryDescription:
                "卡尔加里是加拿大阿尔伯塔省最大的城市，1988年举办了首届冬奥会，在加拿大人口排名第五。<br>由于来自落基山脉的温暖奇努克风，冬季相对其他加拿大地区较为温和。<br>卡尔加里还以其牛仔节、传统音乐节、丁香节和加勒比节而闻名。",
            Mexico: "墨西哥",
            MexicoDescription: "享受墨西哥美丽的风景和丰富的文化。",
            Yellowknife: "黄刀",
            YellowknifeDescription:
                "黄刀是加拿大西北地区首府，被NASA认定为世界上最佳极光观测地点。<br>周围千公里内被山脉环绕，您可以无障碍地欣赏极光。<br>在黄刀体验最佳地面极光旅行。",
            Asia: "亚洲",
            AsiaDescription:
                "体验亚洲的魅力 - 每一次旅程都是传统与创新、自然与城市的融合，带来无与伦比的旅行体验。",
            AccountInfo: "账户信息",
            IntroCEO: "关于我们",
            ContactUs: "联系我们",
            Login: "登录",
            SimpleSignup: "注册",
            Logout: "退出",
            Profile: "个人资料",
            Signup: "注册",
            EmailOrUserName: "用户名或邮箱",
            Password: "密码",
            Email: "邮箱",
            Username: "用户名",
            UsernameReq: "1-50个字符，仅允许数字和字母。",
            PasswordReq: "3-20个字符，允许数字、字母和_!@#$%^&*。",
            CEOPhone: "咨询",
            TripDays: "旅行周期",
            MinPerson: "最少人数",
            Route: "路线",
            Price: "价格",
            TripInquire: "预订咨询",
            WriteTripInquire: "编写预订咨询",
            WriteNew: "新建",
            TripBoardHeader: "预订咨询/旅行评论和问答板",
            Category: "类别",
            Topic: "主题",
            Replies: "回复",
            Clicks: "点击量",
            PostDate: "发布时间",
            NoPost: "暂无帖子。",
            BoardHeader: "产品描述",
            LoginFailed: "登录失败，请重试。",
            Days: "天",
            Persons: "人",
            PlzLogin: "请先登录。",
            WriteLimit: "为防止垃圾信息，每天可写10条。",
            WriteContent: "请至少填写标题和内容。",
            WriteBoard: "新建帖子",
            Title: "标题",
            Post: "发布",
            Close: "关闭",
            Home: "首页",
            RegFailed: "注册失败，请稍后重试。",
            NoTourPackage: "我们正在为该地点准备旅游套餐。",
            Kakao: "通过二维码添加Kakao频道",
            Deleted: "删除成功。",
            NotDeleted: "无法删除，请重试。",
            Updated: "更新成功。",
            NotUpdated: "无法更新，请重试。",
            Update: "修改",
            Delete: "删除",
            AddReply: "添加回复",
            GeneralError: "发生错误，请重试。",
            UnknownError: "发生未知错误，请重试。",
            LoggedOut: "您已退出登录。",
            ToHome: "首页",
            ReplyAdded: "您的回复已添加。",
            Cancel: "取消",
            ConfirmDeletion: "确认删除",
            DeletionMsg: "您确定要删除吗？",
            Confirm: "确认",
            WriteMin: "最少需要10个字符。",
            Product: "产品",
            Essential: "必需品",
            Safety: "安全/注意事项",
            Inexcluded: "包含/不包含",
            RouteDetail: "旅行行程",
            Included: "包含",
            Excluded: "不包含",
            Loading: "加载中...",
            NotLoggedinBoardMsg:
                "发布帖子时，会向管理员发送一封邮件，管理员回复时，回复将发送至注册时使用的邮箱。",
            UseEmailCorrectly:
                "发布帖子时，会向管理员发送一封邮件，若管理员回复，回复将发送至{{email}}。",
            ReplyEmail: "发布帖子时，会向帖子初始发布者和管理员发送一封邮件。",
            Inquire: "咨询",
            TobeNego: "可协商",
            YoutubeText:
                "想与亲人分享珍贵回忆或长久保存？我们的旅行社免费制作YouTube视频！",
            Discounted: "折扣",
            Recommended: "推荐",
            ContactUsTitle: "联系我们",
            ContactUsDescription: "有任何问题？我们将尽快回复。",
            RealTimeConsultation: "如需实时咨询，请使用Kakao Talk。",
            SpamPrevention: "防止垃圾信息",
            EnterNumericAnswer: "请输入数字答案",
            IncorrectAnswer: "答案错误",
            PrivatePost: "私人帖子",
            HideContentInBoard: "在公告板中隐藏内容",
            Sender: "发送者",
            Subject: "主题",
            MinCharacters: "必须至少{{count}}个字符。",
            Content: "内容",
            SpamPreventionLabel: "防止垃圾信息",
            SpamPreventionPlaceholder: "输入结果",
            SpamPreventionIncorrect: "答案错误",
            ConsentLabel: "同意",
            ConsentAgreeText: "同意接收旅游信息、活动和优惠券",
            ConsentNotice:
                "为确保安全交易，关于旅游产品使用、条款和服务变更的通知将无论是否同意都发送。",
            ConsentAllAgreeText: "同意所有条款和隐私政策",
            ConsentTermsAgreeText: "同意条款和条件",
            ConsentPrivacyAgreeText: "同意隐私政策",
            SignUpButton: "注册",
            RegisterTitle: "注册",
            RegisterDescription: "创建新账户以访问LoLo Tour, Ltd.的独家功能。",
            UsernameLabel: "登录ID",
            UsernamePlaceholder: "1-10个字符",
            UsernameInUse: "用户名已被使用",
            UsernameSpecialChar: "用户名不能包含特殊字符",
            EmailLabel: "邮箱",
            EmailPlaceholder: "输入您的邮箱",
            EmailInUse: "邮箱已被使用",
            PasswordLabel: "密码",
            PasswordPlaceholder: "最少6个字符",
            ConfirmPassword: "确认密码",
            PasswordMismatch: "密码不匹配",
            VerifyEmailSubject: "邮箱验证",
            EmailSentSuccess:
                "已向{{email}}发送一封邮件。请点击邮件中的“验证”链接以完成注册。如果5分钟内未收到邮件，请检查您的垃圾邮件文件夹。如果仍未收到，请联系我们。",
            EmailSentError:
                "未能向{{email}}发送邮件。请检查您的邮箱并重新尝试注册。",
            ErrorMessage: "发生错误。请联系我们，我们将尽快解决。",
            Required: "必填",
            EMAIL_VERIFICATION_TITLE: "邮箱验证",
            EMAIL_VERIFICATION_DESCRIPTION1: "要完成注册，您需要验证您的邮箱。",
            EMAIL_VERIFICATION_DESCRIPTION2:
                "加入LoLo Tour，享受在论坛发帖和各种旅行相关福利。",
            EMAIL_VERIFICATION_SUCCESS: "注册完成！请登录。",
            EMAIL_VERIFICATION_FAILURE: "邮箱验证失败。请联系支持团队。",
            EMAIL_DOES_NOT_EXIST: "邮箱不存在。",
            EMAIL_ALREADY_VERIFIED: "邮箱已验证。",
            INCORRECT_CODE: "5位验证码错误。",
            INTERNAL_SERVER_ERROR: "内部服务器错误。请联系支持团队。",
            EMAIL_LABEL: "邮箱",
            CODE_LABEL: "验证码",
            VERIFY_BUTTON_TEXT: "验证",
            VERIFY_EMAIL_SENT_LOADING_TEXT: "正在发送验证邮件...",
            VERIFY_EMAIL_SENT_LOADING_ALT: "加载中",
            EmailFailed:
                "发送邮件失败。请重试或考虑使用KakaoTalk实时聊天支持。",
            ConfirmEmail: "请确认您的邮箱地址。",
            EmailFailedGenericError:
                "发送邮件失败。请重试或考虑使用KakaoTalk实时聊天支持。错误：",
            EmailSent: "邮件已发送。",
            TandC: "条款和条件",
            Privacy: "隐私政策",
            Attention: "参考/注意事项",
            Hire: "招聘",
            TourTitle: "旅行信息",
            Show: "显示",
            Hide: "隐藏",
            ShareProduct: "分享",
            TourName: "旅游名称",
            TourDesc: "旅游描述",
            InteractAddress: "预订存款邮箱",
            Interact: "info@lolotour.com",
            InteractMsg:
                "通过E-transfer（Interact）向info@lolotour.com存款以确认您的预订。",
            OnePersonRule: "备注",
            OnePersonRuleDesc:
                "以下产品价格基于最少4人。如少于3人或额外房间请求，需额外收费，通常为每天CAD$200，除非是单日游。如适用，请咨询。",
            JoinTitle: "有人想一起旅行吗？",
            JoinDesc:
                "为了节省住宿费用等原因，如需加入以下行程，请联系 info@lolotour.com。（需满足最低人数要求，旅行才会进行。）",
            JoinMale: "男",
            JoinFemale: "女",
            JoinStart: "开始日期",
            JoinEnd: "结束日期",
            JoinRemarks: "备注",
            PerPerson: "每人",
            HJKim: "金熙正",
            HJKimRole: "联合首席执行官/导游",
            HJKimRemarks: "金熙正负责大多数旅行。",
            Gil: "薛朱吉",
            GilRole: "平面设计师/导游",
            GilRemarks: "喜欢旅行",
            Kai: "Kai",
            KaiRole: "联合首席执行官/网站/导游",
            KaiRemarks: "",
            Lym: "李琳",
            LymRole: "导游",
            LymRemarks: "仅在请求时负责女性专属旅行。",
            IHKim: "曹日浩",
            IHKimRole: "项目协调员",
            JEKang: "姜贞恩",
            JEKangRole: "导游",
            SMLee: "李秀敏",
            SMLeeRole: "旅游顾问",
            DEHan: "韩斗伊",
            DEHanRole: "导游",
            DEHanRemarks: "潜水教练。滑雪教练。自由潜水2级证书持有者。",
            JadeRole: "导游/宣传",
            JadeRemarks: "精通中文（普通话）、英语和法语",
            beneficiaryBank: "收款银行",
            branchName: "分行名称",
            routingNo: "路由编号",
            beneficiaryBankAddress: "收款银行地址",
            beneficiaryName: "收款人姓名",
            beneficiaryAddress: "收款人地址",
            transitNumber: "分行编号",
            institutionCode: "机构（银行）代码",
            accountNumber: "账户号码",
            swiftBIC: "SWIFT/BIC",
            accountType: "账户类型",
            LinkToTour: "查看此旅游产品",
            TourReview: "旅游评论",
            Logo: "LOLO旅游",
            NumberOfPeople: "旅行者",
            PricePerPerson: "每人价格",
            TotalPrice: "总计",
            Subtotal: "小计",
            GST: "阿尔伯塔GST",
            WON: "韩元",
            PaymentInfo:
                "为确认您的旅行预订，请通过<2>PayPal</2>或<3>Interact</3>向<1>info@lolotour.com</1>支付CAD $20或KRW 20,000的存款。收到存款后，您的预订将被确认，并应要求发送付款确认声明。此存款将从最终付款金额中扣除。请在付款前确保您选择的旅行日期可用。",
            SendEmail: "发送邮件",
            ReadMore: "阅读更多",
            Collapse: "收起",
            LinkedIn: "LinkedIn简介",
            Staff: "员工",
            Car: "车辆",
            CarDesc: "以下车辆用于旅行。",
            CeoGreetingHeader: "首席执行官致辞",
            CeoGreetingText: `你好！🙋‍♂️
            罗洛旅游是一家在卡尔加里正式注册的韩裔私人旅游专业公司。我们为1至4人提供定制私人旅游，从卡尔加里到落基山脉，提供最具性价比的私人旅游。
            <br /><br />
            <ul>
                <li><b>车辆与服务</b>: 我们使用五座雷克萨斯掀背车，开展舒适且高雅的旅行。</li>
                <li><b>本地专业知识</b>: 凭借在卡尔加里生活超过15年的丰富经验和专业知识，我们将卡尔加里和落基山脉的隐藏魅力融入旅游，提供更深入的探索。</li>
                <li><b>定制私人旅游</b>: 充分发挥私人旅游的优势，我们根据客户要求灵活调整行程，承诺为韩国游客的品味和期望量身定制高满意度服务。</li>
            </ul>
            这次旅行可能是您一生中仅有一次的宝贵体验。罗洛旅游将全力以赴，确保您宝贵的时间和投资获得最高价值。现在就联系我们！🚀✨`,
            BiographyHeader: "个人简历",
            Bio1: "韩国陆军中士退役",
            Bio2: "卡尔加里大学计算机科学系毕业",
            Bio3: "赛门铁克首席软件工程师",
            Bio4: "参与多个初创项目",
            companyDescription: `
                    <p>您好！🙋‍♂️ 罗洛旅游是一家在卡尔加里正式注册的小型私人旅游公司。我们提供1至4人的私人旅游服务，自信地提供从卡尔加里到落基山脉最具性价比的韩式私人旅游！🚀✨</p>
        
                    <h5>1️⃣ 罗洛旅游的优势</h5>
                    <ul>
                        <li><strong>透明定价：</strong>我们不从酒店、商店或餐厅收取佣金。我们根据季节和地点寻找性价比高的地点，减少您的麻烦。我们不销售旅游费用之外的优惠券或额外产品。除列明的包含项目外，没有额外费用！</li>
                        <li><strong>定制行程：</strong>我们可以根据您的偏好调整行程，并接受旅行目的地修改的请求。</li>
                        <li><strong>本地隐藏景点：</strong>我们带您前往只有当地导游知道的特殊地点和拍照点，而不仅仅是典型的旅游景点。</li>
                        <li><strong>便捷的交通：</strong>在卡尔加里、坎莫尔和班夫内提供免费接送服务，无额外费用。</li>
                        <li><strong>小型私人旅游：</strong>仅为一个团体提供私人旅游，人数从1人到4人。</li>
                        <li><strong>灵活的行程安排：</strong>如果在旅游前7天取消，将全额退款，仅扣除预订/转账费用（最多C$5）。</li>
                        <li><strong>以摄影为中心的旅游：</strong>如果您对摄影感兴趣，我们可以开展以快照摄影为重点的旅游。</li>
                        <li><strong>本地专业知识：</strong>我们以专业知识和经验为您提供指导，让您尽情享受班夫/落基山脉的每一刻。</li>
                    </ul>
                    
                    <h5>2️⃣ 高级服务</h5>
                    <ul>
                        <li><strong>终身难忘的摄影服务：</strong>凭借在班夫多年拍摄快照的经验，我们将为您捕捉精彩的照片。原始照片将在旅行结束后立即免费发送，无需任何编辑。</li>
                        <li><strong>额外服务：</strong>免费提供雨伞、水和简单小吃。</li>
                    </ul>
                    
                    <h5>3️⃣ 推荐人群</h5>
                    <ul>
                        <li>希望在风景如画的班夫景观中捕捉美丽快照的蜜月情侣。</li>
                        <li>寻求高级旅游的个人旅行者、情侣和家庭旅行者。</li>
                        <li>希望在不拥挤的旅游景点中悠闲享受落基山脉的人。</li>
                    </ul>
                    
                    <h5>✨ 轻松联系我们</h5>
                    <p>这次旅行可能是您一生中一次宝贵的经历。为了确保您精心准备的时间和预算不被浪费，罗洛旅游将为您创造永生难忘的特别回忆。请轻松联系我们，我们将以最高品质的服务回应！</p>
                    
                    <h5>⭕ 其他注意事项</h5>
                    <p>莫雷恩湖班车票在旺季尤其难以预订。如果您希望参观此地点，请在预订确认后尽快咨询。😊</p>`,
            Career: {
                JobPosting: "招聘公告",
                JobDescription:
                    "我们正在寻找有才华的人加入我们位于卡尔加里的LoloTour，卡尔加里顶级的韩国私人旅游公司。",
                CRMManager: "CRM和市场营销经理 (1个职位)",
                JobDetails: "职位详情",
                CRMJobDesc1: "- CRM渠道操作/管理",
                CRMJobDesc2:
                    "为KakaoTalk (朋友聊，通知聊)、应用推送、短信等CRM渠道制定并执行策略。",
                CRMJobDesc3:
                    "根据客户数据和行为得出洞察，制定并执行不同细分市场的CRM策略。",
                CRMJobDesc4:
                    "使用数据分析工具运营、执行、分析并自动化CRM活动。",
                CRMJobResult: "- 分析活动结果并优化成本和效率。",
                CRMJobResult2: "与产品、业务团队等合作，提供客户洞察。",
                CRMOtherTasks: "- 其他各种市场营销工作",
                Qualifications: "资格要求",
                RequiredExperience: "[必需] 3年以上的CRM市场营销经验",
                RequiredSkills: "[必需] 通过数据证明的过往市场营销成绩",
                RequiredTools:
                    "有使用数据工具（如Braze，Airbridge）进行活动规划/执行/分析的经验",
                DecisionMakingSkills: "能够以数据为基础做决策并进行沟通",
                CollaborationSkills:
                    "有跨部门（业务，PO，设计）协作经验，沟通能力强",
                TAManager: "T&A业务开发经理 (1个职位)",
                TAJobDesc1: "开发新的旅游和活动品类，并扩展现有品类。",
                TAJobDesc2: "制定并执行提升旅游和活动收入的战略。",
                TAJobDesc3: "发现新的B2C/B2B合作伙伴，建立战略合作关系。",
                Qualifications2: "我们正在寻找具有以下技能的人:",
                TARequiredSkills: "有制定旅游和活动全球业务战略的经验。",
                TARequiredExperience:
                    "有发现B2C/B2B合作伙伴并建立战略合作关系的经验。",
                PreferredQualifications: "优先资格",
                TAPreferredExperience1:
                    "有初创公司、平台、电商或全球IT公司的工作经验。",
                TAPreferredExperience2: "商务水平的英语沟通能力",
                TourGuide: "旅游导游 (3个职位)",
                TourGuideDesc1: "引导并介绍旅游景点和文化遗产。",
                TourGuideDesc2: "陪同游客并解释当地文化和历史。",
                TourGuideDesc3: "组织各种旅行活动并鼓励参与。",
                Qualifications3: "我们正在寻找具有以下技能的人:",
                TourGuideRequiredSkills1: "3年以上旅游行业经验。",
                TourGuideRequiredSkills2:
                    "对当地历史、文化和美食旅游有深入了解。",
                TourGuideRequiredSkills3:
                    "能够与来自不同国家和语言的游客进行有效沟通。",
                PreferredQualifications2: "优先资格",
                TourGuidePreferredSkills1: "精通外语（英语，中文，日语等）",
                TourGuidePreferredSkills2: "持有当地资格证书",
                TourGuidePreferredSkills3: "持有导游证书",
                TourGuidePreferredSkills4: "有丰富的全球旅行经验",
                ApplicationInstructions: "如何申请",
                SendEmailInstructions:
                    "请将简短的自我介绍和照片（必填）以及简历发送到",
                ClickHere: "点击这里",
                SendLinkedIn: "以发送您的LinkedIn或网站地址。",
            },
        },
    },
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "ca", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
